import React, { useEffect, useState } from 'react'
import { OcrImgBaseUrl } from '../../Config';

export default function ImportGridView({data}) {
    const [row, setRow] = useState(0);
    const [col, setCol] = useState(0);
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
  
    const [OcrOccupied, setOcrOccupied] = useState({});
    const [Occupied, setOccupied] = useState([]);
    useEffect(() => {
        setRow(5);
        setCol(4);
        setWidth("70px");
        setHeight("10vh");
     
      if (
        data?.ocr_grid_wise_occupied &&
        data?.ocr_occupied_area > 0
      ) {
        setOcrOccupied(
          JSON.parse(data?.ocr_grid_wise_occupied) ?? {}
        );
      }
  
    //   data?.ocr_occupied_area > 0 &&
    // data?.occupied_area > 0 &&
      if (
       ( data?.carting_data?.length > 0 ||
        data?.destuffing_data?.length > 0)
      ) {
        let grid_allocation =
          JSON.parse(data?.grid_allocation) ?? {};
        let gridAllocation = [];
        {
          Object.entries(grid_allocation).forEach(([key, value]) => {
            if (!value) return;
            let parsedValues = [];
            if (Array.isArray(value)) {
              parsedValues = value;
            }
            if (!Array.isArray(value)) {
              try {
                parsedValues = JSON.parse(value);
              } catch (error) {
                return;
              }
            }
            if (!Array.isArray(parsedValues)) {
              try {
                parsedValues = JSON.parse(parsedValues);
              } catch (error) {
                return;
              }
            }
            if (Array.isArray(parsedValues)) {
              gridAllocation.push(parsedValues);
            }
          });
        }
        if (gridAllocation) {
          gridAllocation = gridAllocation.flat() ?? [];
          setOccupied(gridAllocation);
        }
      }
    }, [data]);

    return (
      <>
        <h2>{data?.location_code}</h2>
            <div className="d-flex align-items-center justify-content-center">
              <div style={{ width: "260px" }}>
                <div className="main bg-dark p-1 d-flex flex-column border-light border border-2 position-relative w-auto">
                  {[...Array(row)].map((_, rowIndex) => (
                    <div key={rowIndex} className="d-flex">
                      {[...Array(col)].map((_, colIndex) => {
                        const cellValue = rowIndex * 4 + colIndex + 1;
                        // const isSelected = (
                        //   Array.isArray(gridArea) ? gridArea : []
                        // ).includes(cellValue);
                        let color = "bg-secondary";
                        if (
                          OcrOccupied &&
                          OcrOccupied?.data?.[cellValue - 1] &&
                          OcrOccupied?.data?.[cellValue - 1] == "F"
                        ) {
                          color = "bg-info";
                        }
                        if (
                          Occupied &&
                          Occupied.includes(cellValue)
                        ) {
                          color = "bg-primary";
                        }
                        return (
                          <button
                            key={colIndex}
                            className={`border border-light rounded text-white d-flex align-items-center justify-content-center bg-secondary
                                ${color}
                                `}
                            style={{
                              height: height,
                              width: width,
                              fontSize: "18px",
                            }}
                          >
                            {cellValue}
                          </button>
                        );
                      })}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-md-12 my-4">
              <img
                src={OcrImgBaseUrl + data?.ocr_image}
                className="w-50"
                alt=""
              />
            </div>
      </>
    );
}
